import './../../assets/css/App.css';
import './../../assets/css/layout.css';
import './../../assets/css/global/components.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/widgets/datepicker';
import React, { Component } from 'react';
import TableView from './tableView';
import RevenueHistogramByCountry from './revenueHistogramByCountryView';
import RevenueHistogramBySource from './revenueHistogramBySourceView';
import RevenueHistogramBySubject from './revenueHistogramBySubjectView';
import RevenueRepeatSeriesGraph from './revenueSeriesByDayGraphView'
import PageTitle from './../../component/pageTitle'
import AverageRevenueShipmentGraphView from './averageRevenueShipmentGraphView'
import RevenueByDay from './revenueByDayGraphView'
import RevenueGraphViewByMonth from './revenueSeriesByMonthGraphView'

class Dashboard extends Component {
    render() {
        return (
            <div className="page-content-wrapper">
                <PageTitle pageTitle = {"Revenue Statistics Page"} ></PageTitle>
                <div className="page-content tabbable-custom column-xs-12">
                    <TableView></TableView>
                    <div className="graph-border-without-left-margin">
                        <RevenueHistogramBySource></RevenueHistogramBySource>
                    </div>
                </div>
                <div className="graph-border">
                    <RevenueHistogramByCountry></RevenueHistogramByCountry>
                </div>
                <div className="graph-border">
                    <RevenueHistogramBySubject></RevenueHistogramBySubject>
                </div>
                <div className="graph-border">
                    <RevenueRepeatSeriesGraph></RevenueRepeatSeriesGraph>
                </div>
                <div className="graph-border">
                    <RevenueGraphViewByMonth/>
                </div>
                <div className="graph-border">
                    <AverageRevenueShipmentGraphView></AverageRevenueShipmentGraphView>
                </div>
                <div className="graph-border">
                    <RevenueByDay></RevenueByDay>
                </div>
            </div>
        );
    }
}

export default Dashboard;
